export type TenantConfigurationFontColor = 'white' | 'black'

export type SearchTerm = {
  name: string
  fullName: string
}

export type TenantConfigurationCoordinate = {
  latitude: number
  longitude: number
}

export interface ITenantConfigurationProps {
  tenantId: string
  primaryColor?: string
  fontColor: TenantConfigurationFontColor
  minZoomLevel?: number
  startingZoomLevel?: number
  initialCoordinate?: TenantConfigurationCoordinate
  geolocationEnabled?: boolean
  dropOffSubmitEnabled?: boolean
  brandProgram?: string
  mostPopularTags: Array<SearchTerm>
  mostPopularWasteTypes: Array<SearchTerm>
  wasteTypeIds?: Array<string>
  displayOnlyBrandProgramStores?: boolean
}

class TenantConfiguration {
  public readonly tenantId: string
  public readonly primaryColor: string
  public readonly fontColor: TenantConfigurationFontColor
  public readonly minZoomLevel: number
  public readonly startingZoomLevel: number
  public readonly initialCoordinate?: TenantConfigurationCoordinate
  public readonly geolocationEnabled: boolean
  public readonly dropOffSubmitEnabled: boolean
  public readonly brandProgram?: string
  public readonly mostPopularTags: Array<SearchTerm>
  public readonly mostPopularWasteTypes: Array<SearchTerm>
  public readonly wasteTypeIds: Array<string>
  public readonly displayOnlyBrandProgramStores: boolean

  constructor({
                tenantId,
                primaryColor,
                fontColor,
                minZoomLevel,
                startingZoomLevel,
                initialCoordinate,
                dropOffSubmitEnabled,
                geolocationEnabled,
                mostPopularTags,
                mostPopularWasteTypes,
                wasteTypeIds,
                brandProgram,
                displayOnlyBrandProgramStores
              }: ITenantConfigurationProps) {

    this.tenantId = tenantId
    this.primaryColor = primaryColor || '#000000'
    this.fontColor = fontColor
    this.minZoomLevel = minZoomLevel || 10
    this.startingZoomLevel = startingZoomLevel || 10
    this.geolocationEnabled = geolocationEnabled || false
    this.dropOffSubmitEnabled = dropOffSubmitEnabled || false
    this.initialCoordinate = initialCoordinate
    this.mostPopularTags = mostPopularTags
    this.mostPopularWasteTypes = mostPopularWasteTypes
    this.wasteTypeIds = wasteTypeIds || []
    this.brandProgram = brandProgram
    this.displayOnlyBrandProgramStores = displayOnlyBrandProgramStores || false
  }
}

export default TenantConfiguration
